import React from "react";
import { Archive, Trash2, GripVertical } from "lucide-react";

export const NOTE_COLORS = ["#FFE9A8", "#FFD3C4", "#C9E8D0", "#CFE0FF", "#E6D3F5"];

// Légère rotation alternée par index, comme un vrai post-it posé de travers
// (.bn-note:nth-child(3n+2)/(3n+3) dans mon-poste.css).
function rotationFor(index) {
  const mod = index % 3;
  if (mod === 1) return 0.7;
  if (mod === 2) return -0.3;
  return -0.6;
}

const MOIS_COURT = ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."];

function fmtNoteTs(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d)) return "";
  return `${d.getDate()} ${MOIS_COURT[d.getMonth()]} · ${String(d.getHours()).padStart(2, "0")}:${String(
    d.getMinutes()
  ).padStart(2, "0")}`;
}

function StickyNote({
  note,
  index = 0,
  onTextChange,
  onColorChange,
  onArchive,
  onRemove,
  draggable,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  isDragging,
}) {
  return (
    <div
      className="flex flex-col gap-1.5 transition-transform"
      style={{
        background: note.color,
        borderRadius: 4,
        padding: "10px 12px 12px",
        minHeight: 148,
        boxShadow: "0 6px 16px rgba(0,0,0,.12), 0 1px 0 rgba(0,0,0,.04)",
        transform: isDragging ? undefined : `rotate(${rotationFor(index)}deg)`,
        opacity: isDragging ? 0.5 : 1,
      }}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <div className="flex items-center gap-1.5">
        <GripVertical size={14} className="cursor-grab" style={{ color: "rgba(0,0,0,.35)" }} />
        <div className="flex items-center gap-1 ml-0.5">
          {NOTE_COLORS.map((c) => (
            <button
              key={c}
              onClick={() => onColorChange(c)}
              title="Couleur"
              className="w-3.5 h-3.5 rounded-full"
              style={{ background: c, border: `1.5px solid rgba(0,0,0,${note.color === c ? 0.55 : 0.12})` }}
            />
          ))}
        </div>
        <div className="flex items-center gap-0.5 ml-auto">
          <button onClick={onArchive} title="Archiver" className="p-1 rounded" style={{ color: "rgba(0,0,0,.4)" }}>
            <Archive size={13} />
          </button>
          <button onClick={onRemove} title="Supprimer" className="p-1 rounded" style={{ color: "rgba(0,0,0,.4)" }}>
            <Trash2 size={13} />
          </button>
        </div>
      </div>
      <textarea
        value={note.text}
        onChange={(e) => onTextChange(e.target.value)}
        placeholder="Écrire une note…"
        className="flex-1 bg-transparent text-[13px] leading-[1.45] outline-none resize-none"
        style={{ color: "rgba(30,20,10,.9)", fontFamily: '"Segoe Print","Bradley Hand","Comic Sans MS",cursive,system-ui' }}
      />
      {note.createdAt && (
        <div className="text-right" style={{ fontSize: 10, color: "rgba(0,0,0,.42)", marginTop: 2 }}>
          {note.updatedAt && note.updatedAt !== note.createdAt
            ? `Modifié ${fmtNoteTs(note.updatedAt)}`
            : `Créé ${fmtNoteTs(note.createdAt)}`}
        </div>
      )}
    </div>
  );
}

export default StickyNote;
